import dateFns from 'date-fns'

import AppPage from '../../mixins/app-page'

import AppBtnShare from '../app-btn-share'
import AppImgBg from '../app-img-bg'
import AppImg from '../app-img'
import AppYoutube from '../app-youtube'


export default
{
    name: 'page-video-player',

    mixins:
    [
        AppPage
    ],

    components: {
        AppBtnShare,
        AppImgBg,
        AppImg,
        AppYoutube
    },

    data()
    {
        return {
            currentURL: ''
        }
    },

    created()
    {
        this.currentURL = this.$root.$route.path
    },

    mounted()
    {
        this.eventHub.$emit('bg-change', '/static/bg/bg-empty.jpg')
    },

    methods:
    {
        formatDate(timeStamp = 0)
        {
            if (timeStamp <= 0 || timeStamp === undefined)
            {
                return ''
            }

            return dateFns.format(timeStamp * 1000, 'dddd DD[.]MM[.]YYYY')
        },

        _onContentResized()
        {
            this.$emit('load', this)
        }
    }
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-video-player/script.js